import Navigation from "@/components/Navigation";
import Footer from "@/components/Footer";

const Now = () => {
  const lastUpdated = "January 2025";

  return (
    <div className="min-h-screen bg-background">
      <Navigation />
      
      <main className="container mx-auto px-6 pt-32 pb-20">
        <div className="max-w-2xl mx-auto">
          <h1 className="text-5xl font-avenir font-bold mb-4">
            What I'm Doing Now
          </h1>
          
          <p className="text-primary-muted mb-12">
            Last updated: <time dateTime="2025-01">{lastUpdated}</time>
          </p>

          <div className="space-y-8 text-lg leading-relaxed">
            <section>
              <h2 className="text-2xl font-avenir font-semibold mb-4">
                Building an AI Companion for Elderly People
              </h2>
              <p className="text-primary-muted">
                I'm currently developing an AI companion designed to help elderly people 
                stay connected, engaged, and supported. This project combines my passion 
                for technology with a mission to make a meaningful impact on people's lives.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-avenir font-semibold mb-4">
                Launching a Startup Studio
              </h2>
              <p className="text-primary-muted">
                I'm in the process of launching a startup studio to help entrepreneurs 
                turn their ideas into successful businesses. Drawing from my experience 
                as a serial entrepreneur, I'm creating systems and frameworks to accelerate 
                startup success.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-avenir font-semibold mb-4">
                Finding an Agent for My Book
              </h2>
              <p className="text-primary-muted">
                I've written "Shark Snakes and Business Partners," a book about my $2-million 
                lesson in business partnerships. I'm actively seeking a literary agent to 
                help bring this story to a wider audience and help others avoid the costly 
                mistakes I made.
              </p>
            </section>

            <div className="pt-8 mt-12 border-t border-border">
              <p className="text-sm text-primary-muted">
                This is a{" "}
                <a 
                  href="https://nownownow.com/about" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="text-primary hover:underline"
                >
                  now page
                </a>
                , inspired by Derek Sivers. It's a snapshot of what I'm focused on right now.
              </p>
            </div>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default Now;
